<template>
  <div class='headBar' :class="{report_type:report_type_active, normal_type:normal_type_active}">
    <div class="logo">
      <img class="logo_img" src="/static/img/pc_logo.png"/>
      <p class="logo_text" :class="{report_type:report_type_active, normal_type:normal_type_active}" @click="toIndex">微记清单</p>
    </div>
    <div class="right_menu">
      <div class="report_menu" :class="{report_type:report_type_active, normal_type:normal_type_active}">
        <el-dropdown class="project_list_dropdown" trigger="click" :hide-on-click="false" v-show="headbartype === 'normal'">
          <span class="el-dropdown-link project_list">
            项目日程
          </span>
          <el-dropdown-menu class="project_list_dropdown_menu" slot="dropdown">
            <el-dropdown-item><div class="add_project_div" @click="showAddProjectDialog"><i class="icon iconfont icon-add2"></i>添加项目</div></el-dropdown-item>
            <split></split>
            <div class="pro_name_items_div">
              <el-dropdown-item class="pro_name_item" v-for="project in projectList" :key="project.team_no">
                <div class="pro_name" :title="project.team_name">{{project.team_name}}</div>
                <div class="opts">
                  <el-dropdown class="member_dropdown" >
                  <span class="el-dropdown-link member">
                    <i class="icon iconfont icon-renyuan"></i>
                  </span>
                    <el-dropdown-menu class="member_item_more_dropdown_menu" slot="dropdown">
                      <el-dropdown-item><div class="add_member_div" @click="showMemberDialog(project.team_name,project.team_no)"><i class="icon iconfont icon-add2"></i>邀请新同事</div></el-dropdown-item>
                      <split></split>
                      <el-dropdown-item v-for="user in project.userList" :key="user.user_no"><div>{{user.username}}</div></el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-dropdown class="more_dropdown"  >
                  <span class="el-dropdown-link more">
                    <i class="el-icon-more"></i>
                  </span>
                    <el-dropdown-menu class="pro_name_item_more_dropdown_menu" slot="dropdown">
                      <el-dropdown-item><div @click="showEditProjectDialog(project.team_no)"><i class="el-icon-edit-outline"></i>编辑</div></el-dropdown-item>
                      <!--<split></split>-->
                      <el-dropdown-item class="delete"><div @click="deleteProject(project.team_no)"><i class="el-icon-delete"></i>删除</div></el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </el-dropdown-item>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="split" v-show="headbartype === 'normal'">|</span>
        <span class="week" @click="toWeekReport">周报</span>
        <span class="split">|</span>
        <span class="month" @click="toMonthReport">月报</span>
      </div>
     <!-- <div class="member" :class="{report_type:report_type_active, normal_type:normal_type_active}">
        <i class="icon iconfont icon-renyuan"></i>
        <span class="num">8</span>
      </div>-->
      <el-dropdown class="user_center_dropdown" trigger="click">
        <span class="el-dropdown-link user_center">
          {{userInfo.username}}
        </span>
        <el-dropdown-menu class="user_center_dropdown_menu" slot="dropdown">
         <!-- <el-dropdown-item>公司认证</el-dropdown-item>
          <split></split>
          <el-dropdown-item>账号设置</el-dropdown-item>
          <el-dropdown-item>个人信息</el-dropdown-item>-->
          <el-dropdown-item><span @click.prevent="logout">退出登录</span></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import split from '../../others/split_line_1px.vue'
import { mapState } from 'vuex'
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'headbar',
  components: {
    split
  },
  props: {
    headbartype: {
      type: String,
      default: function () {
        return 'normal'
      }
    }
  },
  data: function () {
    return {
    }
  },
  computed: {
    ...mapState([
      'projectList',
      'userInfo'
    ]),
    report_type_active () {
      console.log('report_type_active')
      if (this.headbartype === 'report') {
        return true
      }
      return false
    },
    normal_type_active () {
      console.log('normal_type_active')
      if (this.headbartype === 'normal') {
        return true
      }
      return false
    }
  },
  methods: {
    logout () {
      this.$router.push('/login')
      this.$store.dispatch('setUserInfo', {
        openid: '',
        role: '',
        telephone: '',
        user_no: '',
        username: ''
      })
    },
    toWeekReport () {
      this.$store.dispatch('setReportType', 'week')
      this.$store.dispatch('setReportStartTime', moment().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'))
      this.$store.dispatch('setReportEndTime', moment().endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'))
      this.$router.push('/report')
    },
    toMonthReport () {
      this.$store.dispatch('setReportType', 'month')
      this.$store.dispatch('setReportStartTime', moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'))
      this.$store.dispatch('setReportEndTime', moment().endOf('month').format('YYYY-MM-DD HH:mm:ss'))
      this.$router.push('/report')
    },
    toIndex () {
      this.$router.push('/')
    },
    showMemberDialog (teamName, teamNo) {
      let data = {
        visible: true,
        team_name: teamName,
        team_no: teamNo
      }
      this.$store.dispatch('setMemberDialog', data)
    },
    showAddProjectDialog () {
      let data = {
        visible: true,
        method: 'add',
        no: ''
      }
      this.$store.dispatch('setProjectDialog', data)
    },
    showEditProjectDialog (teamNo) {
      let data = {
        visible: true,
        method: 'edit',
        no: teamNo
      }
      this.$store.dispatch('setProjectDialog', data)
    },
    closeAddProjectDialog () {
      this.addProjectDialogVisible = false
    },
    deleteProject (teamNo) {
      let _this = this
      axios({
        method: 'get',
        url: _this.HOST + '/company/updateTeam',
        params: {
          team_no: teamNo,
          is_delete: 1
        }
      }).then((res) => {
        let data = res.data
        console.log('删除项目')
        console.log(data)
        if (data.statusCode === 200) {
          _this.$store.dispatch('setProjectList')
        } else {
          console.log(data.message)
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .member_item_more_dropdown_menu
    width 8.625rem
  .pro_name_item_more_dropdown_menu
    width 5.625rem
  .member_item_more_dropdown_menu,.el-dropdown-menu--medium,
  .pro_name_item_more_dropdown_menu,.el-dropdown-menu--medium
    padding 0 !important
    cursor pointer
    .el-dropdown-menu__item
      div
        padding 0 1.0625rem
    li:hover
      color $lightGrey !important
      background-color $bgGray !important
    li
      padding 0 !important
      height 2rem
      line-height 2rem
      color $tinGrey
      font-size 14px
      text-align left
      i
        font-size 14px
        margin-right 0.625rem
      .add_member_div
        color $darkBlue
        i
          margin-right 0.5rem
          color $darkBlue
    .delete
      color $darkRed
    .invite_new_member
      color $elemBlue
    .split_line_1px
      width 80%
      margin-left 10%
  .project_list_dropdown
    padding-top 0
    font-size 1.125rem
    color $lightGrey
    cursor pointer
  .user_center_dropdown
    padding-top 0.625rem
  .project_list_dropdown_menu
    .pro_name_items_div
      max-height 20rem
      overflow-y auto
      .pro_name_item
        display flex
        padding 0
        div
          padding 0
        .pro_name
          text-align left
          padding-left 1rem
          padding-right 0.5rem
          flex 4
          overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap
        .opts
          flex 2
          .el-icon-more,
          .icon-renyuan
            color $tinGrey
          .el-icon-more:hover,
          .icon-renyuan:hover
            color $elemBlue
  .user_center_dropdown_menu.el-dropdown-menu--medium,
  .project_list_dropdown_menu.el-dropdown-menu--medium
    width 10.5rem
    padding 0 !important
    li
      padding 0 !important
      height 2.5rem
      line-height 2.5rem
      font-size 1rem
      text-align center
      font-weight 400
    .add_project_div
      color $darkBlue
      i
        margin-right 0.5rem
        color $darkBlue
    .split_line_1px
      width 80%
      margin-left 10%
  .user_center_dropdown_menu,
  .project_list_dropdown_menu
    li:hover
      color $pepperGrey
      background-color $bgGray
  .project_list_dropdown_menu.el-dropdown-menu--medium
    width 13.5rem
  .headBar.report_type
    box-shadow 0 0 0 0
    -moz-box-shadow 0 0 0 0
    -webkit-box-shadow 0 0 0 0
  .headBar.normal_type
    box-shadow 0 0.25rem 0.25rem 0 $shadowGray
    -moz-box-shadow 0 0.25rem 0.25rem 0 $shadowGray
    -webkit-box-shadow 0 0.25rem 0.25rem 0 $shadowGray
  .headBar
    width 100%
    height 3.75rem
    z-index 10
    .logo
      height 3.75rem
      width 10rem
      margin-left 2.5rem
      line-height 3.75rem
      font-size 0rem
      display inline-block
      vertical-align top
      text-align left
      .logo_img
        width 2.25rem
        height 2.25rem
        display inline-block
        vertical-align middle
      .logo_text.report_type
        color $white
      .logo_text.normal_type
        color $pepperGrey
      .logo_text
        margin-left 1.5rem
        display inline-block
        vertical-align middle
        font-size 1.125rem
        font-weight 500
        cursor pointer
    .right_menu
      height 3.75rem
      width 25rem
      margin-right  2.8125rem
      line-height 3.75rem
      display inline-block
      text-align right
      float right
      .el-dropdown
        height 3.125rem
        .user_center
          display inline-block
          width 2.5rem
          height 2.5rem
          border-radius 50%
          background $elemBlue
          text-align center
          line-height 2.5rem
          color $white
          overflow hidden
          cursor pointer
      .member.report_type
        color $white
      .member.normal_type
        color $lightGrey
      .member
        display inline-block
        margin-right 1.625rem
        vertical-align top
        .icon
          width 1.25rem
          height 1.25rem
          font-size 1.25rem
          background transparent
        .num
          font-size 0.875rem
      .report_menu.report_type
        color $white
      .report_menu.normal_type
        color $lightGrey
      .report_menu
        display inline-block
        vertical-align top
        margin-right 1.625rem
        .week
          font-size 1.125rem
          cursor pointer
        .month
          font-size 1.125rem
          cursor pointer
        .split
          font-size 1.125rem
          padding 0 0.75rem
</style>



// WEBPACK FOOTER //
// src/pagesPc/main/component/headBar.vue